var React = require('react');

function EmailIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.39 0c-.182 0-.355.038-.514.101l8.066 6.837c.353.299.747.299 1.1 0L18.118.093C17.96.034 17.789 0 17.61 0H1.39zM.014 1.183C.005 1.248 0 1.317 0 1.385v9.23C0 11.383.62 12 1.39 12h16.22c.77 0 1.39-.617 1.39-1.385v-9.23c0-.068-.005-.137-.014-.202L10.948 7.99c-.834.706-2.078.707-2.91 0L.013 1.183z"}));
}

EmailIcon.defaultProps = {"viewBox":"0 0 19 12"};

module.exports = EmailIcon;

EmailIcon.default = EmailIcon;
